import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import {
    Text,
    Image,
    Box,
    Stack,
    VStack,
    HStack,
    Link,
} from "@chakra-ui/react";
import linkedInIcon from "../assets/LinkedIn-icon.svg";
import logoBlack from "../assets/logo-black.svg";

export default function Footer() {
    return (
        <Box>
            <Box
                bg="navy.500"
                p={{ base: "3em 2em", lg: "5em 4em" }}
            >
                <Stack
                    direction={{ base: "column", lg: "row" }}
                    spacing={8}
                    align={{ base: "start", lg: "start" }}
                    justify="space-between"
                >
                    {/* Company Info */}
                    <VStack
                        align="start"
                        w={{ base: "100%", lg: "30%" }}
                        spacing={3}
                    >
                        <Text color="white" fontWeight="600" fontSize="lg">
                            BetaPersona
                        </Text>
                        <Text color="white" fontSize="sm">
                            A product of Digitalfields Europe Ltd
                        </Text>
                        <Text color="white" fontSize="sm">
                            Company number 15999199
                        </Text>
                        <Text color="white" fontSize="sm">
                            85 Great Portland Street, First Floor
                        </Text>
                        <Text color="white" fontSize="sm">
                            London W1W 7LT
                        </Text>
                        <Text color="white" fontSize="sm">
                            United Kingdom
                        </Text>
                    </VStack>

                    {/* Product Links */}
                    <VStack
                        align="start"
                        w={{ base: "100%", lg: "30%" }}
                        spacing={3}
                    >
                        <Text color="white" fontWeight="600" fontSize="md" mb={2}>
                            Product
                        </Text>
                        <Link
                            as={ReactRouterLink}
                            to="/how-it-works"
                            color="white"
                            fontSize="sm"
                            _hover={{ opacity: 0.8 }}
                        >
                            How it works
                        </Link>
                        <Link
                            as={ReactRouterLink}
                            to="/hrbp"
                            color="white"
                            fontSize="sm"
                            _hover={{ opacity: 0.8 }}
                        >
                            HRBP
                        </Link>
                        <Link
                            as={ReactRouterLink}
                            to="/recruiters"
                            color="white"
                            fontSize="sm"
                            _hover={{ opacity: 0.8 }}
                        >
                            Talent acquisition
                        </Link>
                        <Link
                            as={ReactRouterLink}
                            to="/professionals"
                            color="white"
                            fontSize="sm"
                            _hover={{ opacity: 0.8 }}
                        >
                            Occupational psychologists
                        </Link>
                    </VStack>

                    {/* Company Links */}
                    <VStack
                        align="start"
                        w={{ base: "100%", lg: "30%" }}
                        spacing={3}
                    >
                        <Text color="white" fontWeight="600" fontSize="md" mb={2}>
                            Company
                        </Text>
                        <Link
                            as={ReactRouterLink}
                            to="/security-and-data"
                            color="white"
                            fontSize="sm"
                            _hover={{ opacity: 0.8 }}
                        >
                            Security & data
                        </Link>
                        <Link
                            as={ReactRouterLink}
                            to="/about"
                            color="white"
                            fontSize="sm"
                            _hover={{ opacity: 0.8 }}
                        >
                            About
                        </Link>
                        <Link
                            as={ReactRouterLink}
                            to="/contact"
                            color="white"
                            fontSize="sm"
                            _hover={{ opacity: 0.8 }}
                        >
                            Talk to us
                        </Link>
                        <HStack spacing={3} pt={2}>
                            <Text color="white" fontSize="sm">
                                LinkedIn
                            </Text>
                            <Link
                                href="https://www.linkedin.com/products/digitalfields-betapersonacom/"
                                target="_blank"
                                _hover={{ opacity: 0.8 }}
                            >
                                <Image src={linkedInIcon} alt="LinkedIn" w={6} h={6} />
                            </Link>
                        </HStack>
                    </VStack>
                </Stack>
            </Box>
            <Box bg="offwhite.200" p="4" textAlign="center">
                <Image src={logoBlack} alt="BetaPersona Logo" h={8} mx="auto" />
            </Box>
        </Box>
    );
}
